var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { getRebornUrl } from '@/shared/utils/helpers';
let ShopReborn = class ShopReborn extends Vue {
    constructor() {
        super(...arguments);
        this.retryTimers = [];
        this.tokenPollTimer = null;
        this.lastSentToken = '';
    }
    /**
     * Mantém a rota do Shop sincronizada entre o V3 e o Reborn.
     *
     * Exemplos:
     *
     * V3
     *   /shop/config/record-app
     *
     * Reborn
     *   /shop/config/record-app
     */
    get iframeSrc() {
        return `${getRebornUrl()}${this.$route.fullPath}`;
    }
    sendInit() {
        const iframe = this.$refs.iframe;
        if (!iframe || !iframe.contentWindow) {
            return;
        }
        const token = localStorage.getItem('auth_token_default') || '';
        this.lastSentToken = token;
        iframe.contentWindow.postMessage({
            type: 'SHOP_INIT',
            token,
            infosetId: this.$route.query.infosetId,
        }, '*');
    }
    onIframeLoad() {
        this.stopSessionRecovery();
        this.sendInit();
        /**
         * Evita race condition entre o carregamento
         * do iframe e a inicialização do React.
         */
        this.retryTimers.push(setTimeout(() => this.sendInit(), 500));
        this.retryTimers.push(setTimeout(() => this.sendInit(), 2000));
    }
    startSessionRecovery() {
        if (this.tokenPollTimer) {
            return;
        }
        this.sendInit();
        this.tokenPollTimer = setInterval(() => {
            const current = localStorage.getItem('auth_token_default') || '';
            if (current && current !== this.lastSentToken) {
                this.sendInit();
                this.stopSessionRecovery();
            }
        }, 500);
        this.retryTimers.push(setTimeout(() => this.stopSessionRecovery(), 10 * 60 * 1000));
    }
    stopSessionRecovery() {
        if (this.tokenPollTimer) {
            clearInterval(this.tokenPollTimer);
            this.tokenPollTimer = null;
        }
    }
    handleMessage(event) {
        if (!event.data) {
            return;
        }
        switch (event.data.type) {
            case 'IFRAME_READY':
                this.sendInit();
                break;
            case 'SESSION_EXPIRED':
                this.startSessionRecovery();
                break;
        }
    }
    mounted() {
        window.addEventListener('message', this.handleMessage);
    }
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
        this.stopSessionRecovery();
        this.retryTimers.forEach(clearTimeout);
        this.retryTimers = [];
    }
};
ShopReborn = __decorate([
    Component({
        name: 'ShopReborn',
    })
], ShopReborn);
export default ShopReborn;
